import { useMutation } from '@apollo/client';
import { CLEAR_NOTIFICATIONS_COUNT } from '../apollo-client/mutations';

/**
 * Hook to handle notifications count mutation
 * Returns a function to clear notifications count
 */
export const useClearNotificationsCount = (userData) => {
  const [clearNotificationsCount] = useMutation(CLEAR_NOTIFICATIONS_COUNT, {
    optimisticResponse: {
      __typename: "Mutation",
      clearNotificationsCount: {
        _id: userData?.user?._id,
        newNotificationsCount: 0,
        __typename: "User",
      },
    },
  });

  return clearNotificationsCount;
};
